// extracted by mini-css-extract-plugin
export var container = "article-module--container--2BO4e";
export var headline = "article-module--headline--xr_N6";
export var pretitle = "article-module--pretitle--P3iMC";
export var title = "article-module--title--1Ua8G";
export var prebody = "article-module--prebody--1hmu-";
export var body = "article-module--body--14eKs";
export var mainImage = "article-module--mainImage--nd_79";
export var masonry = "article-module--masonry--1cxGF";
export var item = "article-module--item--2Pn10";